import { createSlice, createSelector } from "@reduxjs/toolkit";
import { authApiSlice } from "./authApiSlice";
import jwt from "jwt-decode";
import config from "../../config.json";

const tokenKey = "token";

const slice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    tempToken: null,
    tempRefreshToken: null,
    loading: false,
    userDetails: null,
    partnerUserDetails: null,
    updateStatus: null,
    hostDetails: null,
    emailOtpSentStatus: "",
    verifyOtpStatus: "",
    validateStatus: false,
    loginFailedStatus: "",
    picUpdatedStatus: false,
    LogoUpdatedStatus: false,
    updateddatarecieved: null,
    profilePic: null,
    profileLogo: null,
    profilePicTwo: null,
    clientDetails: null,
    loginLogoutStatus: null,
  },
  reducers: {
    login: (auth, action) => {
      auth.user = action.payload;
      auth.token = null;
    },
    loginFailed: (auth, action) => {
      auth.loginFailedStatus = action.payload;
      auth.user = null;
      auth.token = null;
    },
    emailOtpReceived: (auth, action) => {
      auth.emailOtpSentStatus = action.payload;
      auth.verifyOtpStatus = "";
    },
    verifiedOtp: (auth, action) => {
      auth.verifyOtpStatus = action.payload;
      auth.emailOtpSentStatus = "";
    },
    verifiedOtpFailed: (auth, action) => {
      auth.verifyOtpStatus = "";
      auth.emailOtpSentStatus = "";
    },
    hostDetailsAdded: (auth, action) => {
      auth.hostDetails = action.payload;
    },
    validateUser: (auth, action) => {
      auth.user = action.payload;
      auth.token = action.payload?.token;
      auth.validateStatus = true;
    },
    finalizeLogin: (auth, action) => {
      auth.token = auth.tempToken || auth.user?.token;
      auth.validateStatus = true;
      if (auth.token) {
        localStorage.setItem("token", auth.token);
      }
      if (auth.tempRefreshToken) {
        localStorage.setItem("refreshToken", auth.tempRefreshToken);
      }
      auth.tempToken = null;
      auth.tempRefreshToken = null;
    },
    logout: (auth, action) => {
      auth.user = null;
      auth.token = null;
      auth.validateStatus = false;
    },
    refresh: (auth, action) => {
      const { user, token } = action.payload;
      auth.user = user;
      auth.token = token;
    },
    setLoginUserType: (auth, action) => {
      auth.user = { ...auth.user, ...action.payload };
    },
    loggedUserDetailsReceived: (auth, action) => {
      auth.userDetails = action.payload;
      auth.updateStatus = null;
    },
    loggedPartnerUserDetailsReceived: (auth, action) => {
      auth.partnerUserDetails = action.payload;
      auth.updateStatus = null;
    },
    loginLogoutStatusReceived: (auth, action) => {
      auth.loginLogoutStatus = action.payload;
    },
    userDetailsUpdated: (auth, action) => {
      auth.updateStatus = action.payload;
      auth.userDetails = null;
      auth.partnerUserDetails = null;
    },
    userProfilePicUpdated: (auth, action) => {
      auth.picUpdatedStatus = action.payload;
    },
    userProfileLogoUpdated: (auth, action) => {
      auth.LogoUpdatedStatus = action.payload;
    },
    loginStatusDataUpdated: (auth, action) => {
      auth.updateddatarecieved = action.payload;
    },
    profilePicReceived: (auth, action) => {
      auth.profilePic = action.payload;
      auth.picUpdatedStatus = false;
    },
    profileLogoReceived: (auth, action) => {
      auth.profileLogo = action.payload;
      auth.LogoUpdatedStatus = false;
    },
    profilePicReceivedTwo: (auth, action) => {
      auth.profilePicTwo = action.payload;
      auth.picUpdatedStatus = false;
    },
    clientDetailsRecevied: (auth, action) => {
      auth.clientDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        authApiSlice.endpoints.login.matchFulfilled,
        (auth, action) => {
          auth.user = action.payload;
          auth.tempToken = action.payload?.token;
          auth.tempRefreshToken = action.payload?.refreshToken;
          auth.token = null;
          auth.loginFailedStatus = "";
        }
      )
      .addMatcher(
        authApiSlice.endpoints.login.matchRejected,
        (auth, action) => {
          auth.loginFailedStatus = action.payload || action.error?.message || "Login failed";
          auth.user = null;
          auth.token = null;
          auth.tempToken = null;
          auth.tempRefreshToken = null;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.validateUser.matchFulfilled,
        (auth, action) => {
          auth.user = action.payload;
          auth.token = action.payload?.token;
          auth.validateStatus = true;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.refreshToken.matchFulfilled,
        (auth, action) => {
          const accessToken = action.payload?.accessToken || action.payload?.AccessToken || action.payload?.token;
          if (accessToken) {
            auth.token = accessToken;
          }
          if (auth.user) {
            auth.user.token = accessToken;
          }
        }
      )
      .addMatcher(
        authApiSlice.endpoints.getUserDetails.matchFulfilled,
        (auth, action) => {
          auth.userDetails = action.payload;
          auth.updateStatus = null;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.getPartnerUserDetails.matchFulfilled,
        (auth, action) => {
          auth.partnerUserDetails = action.payload;
          auth.updateStatus = null;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.updateLoginLogoutStatus.matchFulfilled,
        (auth, action) => {
          auth.loginLogoutStatus = action.payload;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.addHostDetails.matchFulfilled,
        (auth, action) => {
          auth.hostDetails = action.payload;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.getUserProfilePic.matchFulfilled,
        (auth, action) => {
          auth.profilePic = action.payload;
          auth.picUpdatedStatus = false;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.getUserProfileLogo.matchFulfilled,
        (auth, action) => {
          auth.profileLogo = action.payload;
          auth.LogoUpdatedStatus = false;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.updateProfileData.matchFulfilled,
        (auth, action) => {
          auth.updateStatus = action.payload;
          auth.userDetails = null;
          auth.partnerUserDetails = null;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.uploadProfilePic.matchFulfilled,
        (auth, action) => {
          auth.picUpdatedStatus = action.payload;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.uploadCompanyLogo.matchFulfilled,
        (auth, action) => {
          auth.LogoUpdatedStatus = action.payload;
        }
      )
      .addMatcher(
        authApiSlice.endpoints.updateLoginStatus.matchFulfilled,
        (auth, action) => {
          auth.updateddatarecieved = action.payload;
          if (auth.userDetails) {
            if (auth.userDetails.maxtasks === null) {
              auth.userDetails.maxtasks = 1;
            } else if (auth.userDetails.maxtasks === 1) {
              auth.userDetails.maxtasks = 2;
            }
          }
          if (auth.partnerUserDetails) {
            if (auth.partnerUserDetails.maxtasks === null) {
              auth.partnerUserDetails.maxtasks = 1;
            } else if (auth.partnerUserDetails.maxtasks === 1) {
              auth.partnerUserDetails.maxtasks = 2;
            }
          }
        }
      )
      .addMatcher(
        authApiSlice.endpoints.sendSecurityCodeToEmail.matchFulfilled,
        (auth, action) => {
          auth.emailOtpSentStatus = action.payload;
          auth.verifyOtpStatus = "";
        }
      )
      .addMatcher(
        authApiSlice.endpoints.verifySecurityCode.matchFulfilled,
        (auth, action) => {
          auth.verifyOtpStatus = action.payload;
          auth.emailOtpSentStatus = "";
        }
      )
      .addMatcher(
        authApiSlice.endpoints.verifySecurityCode.matchRejected,
        (auth, action) => {
          auth.verifyOtpStatus = "";
          auth.emailOtpSentStatus = "";
        }
      )
      .addMatcher(
        authApiSlice.endpoints.getClientDetails.matchFulfilled,
        (auth, action) => {
          auth.clientDetails = action.payload;
        }
      );
  },
});

export const {
  login,
  logout,
  refresh,
  setLoginUserType,
  loggedUserDetailsReceived,
  hostDetailsAdded,
  loginLogoutStatusReceived,
  userDetailsUpdated,
  emailOtpReceived,
  verifiedOtp,
  validateUser,
  verifiedOtpFailed,
  loginFailed,
  userProfilePicUpdated,
  userProfileLogoUpdated,
  loginStatusDataUpdated,
  profilePicReceived,
  profileLogoReceived,
  profilePicReceivedTwo,
  clientDetailsRecevied,
  loggedPartnerUserDetailsReceived,
  finalizeLogin,
} = slice.actions;
export default slice.reducer;

export const sign = (email, password) => {
  const challengeId = localStorage.getItem("challengeId");
  return authApiSlice.endpoints.login.initiate({
    challengeId: challengeId,
    username: email,
    password: password,
  });
};

export const validate = (userId, email, pwd) =>
  authApiSlice.endpoints.validateUser.initiate({
    userId: userId,
    email: email,
    userType: "applicant",
    password: pwd,
  });

export const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return authApiSlice.endpoints.refreshToken.initiate(refreshToken);
};

export const loadUserDetails = (id) =>
  authApiSlice.endpoints.getUserDetails.initiate(id);

export const loadPartnerUserDetails = (id) =>
  authApiSlice.endpoints.getPartnerUserDetails.initiate(id);

export const loginLogoutUpdateStatus = (id) => {
  const refreshToken = localStorage.getItem("refreshToken");
  return authApiSlice.endpoints.updateLoginLogoutStatus.initiate(refreshToken);
};

export const AddHostDetails = (data) =>
  authApiSlice.endpoints.addHostDetails.initiate(data);

export const loadUserProfilePic = (id) =>
  authApiSlice.endpoints.getUserProfilePic.initiate(id);

export const loadUserProfileLogo = (id) =>
  authApiSlice.endpoints.getUserProfileLogo.initiate(id);

export const loadUserProfilePicTwo = (id) =>
  authApiSlice.endpoints.getUserProfilePic.initiate(id);

export const UpdateUserDetails = (data) =>
  authApiSlice.endpoints.updateProfileData.initiate(data);

export const updateUserProfilePic = (data) =>
  authApiSlice.endpoints.uploadProfilePic.initiate(data);

export const updateUserLogoPic = (data) =>
  authApiSlice.endpoints.uploadCompanyLogo.initiate(data);

export const loginStatusUpdate = (id) =>
  authApiSlice.endpoints.updateLoginStatus.initiate(id);

export const SendOTPEmail = (username, email) =>
  authApiSlice.endpoints.sendSecurityCodeToEmail.initiate({ username, email });

export const VerifyOTPEmail = (email, code) =>
  authApiSlice.endpoints.verifySecurityCode.initiate({ email, code });

export const loadClientDetails = () =>
  authApiSlice.endpoints.getClientDetails.initiate();

export const getLoggedUser = createSelector(
  (state) => state.auth,
  (auth) => auth
);

export const getLoggedUserDetails = createSelector(
  (state) => state.auth,
  (auth) => auth.userDetails
);

export const getLoggedPartnerUserDetails = createSelector(
  (state) => state.auth,
  (auth) => auth.partnerUserDetails
);

export const getLoggedUserToken = createSelector(
  (state) => state.auth,
  (auth) => auth.token
);

export const getUserUpdateStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.updateStatus
);

export const getOtpSentStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.emailOtpSentStatus
);

export const getOtpVerifyStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.verifyOtpStatus
);

export const getValidateStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.validateStatus
);

export const getLoginFailedStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.loginFailedStatus
);

export const getHostDetails = createSelector(
  (state) => state.auth,
  (auth) => auth.hostDetails
);

export const getPicUpdatedStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.picUpdatedStatus
);

export const getLogoUpdatedStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.LogoUpdatedStatus
);

export const getloginupdatedstatus = createSelector(
  (state) => state.auth,
  (auth) => auth.updateddatarecieved
);

export const getUserProfilePic = createSelector(
  (state) => state.auth,
  (auth) => auth.profilePic
);

export const getUserProfileLogo = createSelector(
  (state) => state.auth,
  (auth) => auth.profileLogo
);

export const getLoginLogoutUserStatus = createSelector(
  (state) => state.auth,
  (auth) => auth.loginLogoutStatus
);

export const getUserProfilePicTwo = createSelector(
  (state) => state.auth,
  (auth) => auth.profilePicTwo
);

export const getCurrentClientDeatils = createSelector(
  (state) => state.auth,
  (auth) => auth.clientDetails
);

export const getCurrentUser = () => {
  try {
    const tk = localStorage.getItem(tokenKey);
    const decode = jwt(tk);
    const logType = localStorage.getItem("loginType");
    // if (logType === "ad") {
    //   decode.id = 1;
    //   decode.type = "admin";
    // }
    return decode;
  } catch (error) {
    return null;
  }
};
